import { cn } from "@/lib/utils";

interface LogoLoaderProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function LogoLoader({ className, size = "md" }: LogoLoaderProps) {
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-12 w-12",
    lg: "h-16 w-16",
  };

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div className="relative">
        {/* Outer pulse ring */}
        <div className="absolute inset-0 rounded-full bg-primary/20 animate-ping" />
        
        {/* Logo container */}
        <div className={cn(
          "relative rounded-full bg-background border border-primary/20 flex items-center justify-center",
          sizeClasses[size]
        )}>
          <img 
            src="/moltjobs-logo.svg" 
            alt="Loading..." 
            className={cn(
              "object-contain animate-pulse",
              size === "sm" ? "h-5 w-5" : size === "md" ? "h-8 w-8" : "h-10 w-10"
            )}
          />
        </div>
      </div>
    </div>
  );
}

// Full page loader for initial app load
export function PageLoader() {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-background gap-4">
      <LogoLoader size="lg" />
      <p className="text-muted-foreground text-sm font-mono animate-pulse">Loading...</p>
    </div>
  );
}

// Inline loader for components
export function InlineLoader({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center justify-center py-8", className)}>
      <LogoLoader size="md" />
    </div>
  );
}
